import React from "react";
import ProfileScreen from "./ProfileScreen";
import useProfileFacts from "./useProfileFacts";

// Joins the server facts (email, school, chat count) to the screen.
export default function ProfilePage(props) {
  const facts = useProfileFacts();
  return <ProfileScreen {...props} email={facts.email} inSchool={facts.inSchool} chatCount={facts.chatCount} />;
}
